import { COSMETICS, RARITIES, type Cosmetic, type Rarity } from '../content/cosmetics';
import { economyRandom, type IntegerRandom } from './economyRandom';

export const RARITY_WEIGHTS: Readonly<Record<Rarity, number>> = { N: 5000, R: 3500, SR: 1200, SSR: 239, UR: 60, EXR: 1 };
export type PullCount = 1 | 10;
export function phaseRewardRange(phase: number): Readonly<{ min: number; max: number }> {
  if (!Number.isInteger(phase) || phase < 1 || phase > 5) throw new RangeError('Invalid resonance phase');
  const min = (phase - 1) * 100;
  return { min, max: min * 1.5 };
}
export function rollPhaseReward(phase: number, random: IntegerRandom = economyRandom): number {
  const { min, max } = phaseRewardRange(phase);
  if (min === 0) return 0;
  const value = random(max - min + 1);
  if (!Number.isInteger(value) || value < 0 || value > max - min) throw new RangeError('Invalid phase reward random');
  return min + value;
}
export function pullCost(count: number): number {
  if (count !== 1 && count !== 10) throw new RangeError('Pull count must be 1 or 10');
  return count * 100;
}
export function validateCatalog(items: readonly Cosmetic[] = COSMETICS): void {
  if (items.length !== COSMETICS.length || new Set(items.map(item => item.id)).size !== items.length) throw new Error('Invalid cosmetic catalog');
  for (const expected of COSMETICS) {
    const item = items.find(candidate => candidate.id === expected.id);
    if (!item || item.initial || item.rarity !== expected.rarity || item.kind !== expected.kind || !item.image || !item.thumbnail) {
      throw new Error('Incomplete cosmetic catalog');
    }
  }
}
export function rollRarity(random: IntegerRandom = economyRandom): Rarity {
  const target = random(10000);
  if (!Number.isInteger(target) || target < 0 || target >= 10000) throw new RangeError('Invalid rarity random');
  let ceiling = 0;
  for (const rarity of RARITIES) {
    ceiling += RARITY_WEIGHTS[rarity];
    if (target < ceiling) return rarity;
  }
  throw new Error('Invalid rarity weights');
}
export function rollCosmetic(random: IntegerRandom = economyRandom): Cosmetic {
  const rarity = rollRarity(random);
  const candidates = COSMETICS.filter(item => item.rarity === rarity);
  const index = random(candidates.length);
  const item = Number.isInteger(index) && index >= 0 ? candidates[index] : undefined;
  if (!item) throw new RangeError('Invalid item random');
  return item;
}
export function rollClearReward(random: IntegerRandom = economyRandom): number {
  const value = random(8901);
  if (!Number.isInteger(value) || value < 0 || value > 8900) throw new RangeError('Invalid reward random');
  return 100 + value;
}
